console.log('Hello World!!');

import {slideMenuToggle} from './module/_slideMenu'
import {headerFixed} from './module/_headerFixed'
import {sliderSettings} from "./module/_sliderSettings";
import {searchForm} from "./module/_searchForm";
import {formAction} from "./module/_page-contact";


const fixedContactMargin = function () {
    const fixedContact = document.getElementById('fixedContact');

    if (fixedContact || matchMedia('(max-width: 768px)')) {
        document.body.style.setProperty('margin-bottom', fixedContact.clientHeight + 'px')
    }
}


sliderSettings();
fixedContactMargin();
slideMenuToggle();
headerFixed();
searchForm();
formAction();